export const updateCommentAPI = '/comment/release';
export const deleteCommentAPI = '/comment/delete';
export const interactionCommentAPI = '/comment/interaction';
export const forwardCommentAPI = '/comment/relay';
export const listCommentAPI = '/comment/list';
export const listMyCommentAPI = '/comment/my/list';
export const listStreamerCommentAPI = '/streamer/comment/list';
export const listStreamerAPI = '/streamer/list';
export const listCommentStreamerAPI = '/comment/streamer/list';
